import React, {useState, useEffect} from "react";
import Modal from "react-modal";
import Web3 from "web3";
import Staking from '../abi/Staking.json'
import Swal  from "sweetalert2";
import { parseUnits } from "ethers";
import { txAfterDone, txDone, txStart } from '../../../helper/Helper';

const UnstakeModal = ({ modalIsOpen, closeModal, account, providers, stakedpTGC, updatePage}) => {
  const [amount, setAmount] = useState('');
  const MAX_UNSTAKE_BPS = 9950;
  const BPS_DENOMINATOR = 10000;
  const getMaxUnstakeAmount = () => {
    return (Number(stakedpTGC) * MAX_UNSTAKE_BPS) / BPS_DENOMINATOR;
  };
  
  useEffect(() => {
      const maxUnstakeAmount = getMaxUnstakeAmount();
      if (Number(amount) > maxUnstakeAmount) {
        setAmount(maxUnstakeAmount.toString());
      }

      if (Number(amount) > stakedpTGC) {
        setAmount(stakedpTGC)
      }
      if (String(amount).includes(".")) {
          let input_string = String(amount)
          let newAmount = input_string.match(/^\d+\.\d{0,0}/)[0]
          setAmount(Number(newAmount))
      }
  }, [amount, stakedpTGC]);

  const unstake = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const finalAmount = parseUnits(String(amount), 18);
    try {
      await stakingContract.methods.withdraw(finalAmount).send({
        from: account
      }).on('transactionHash', function(payload) {
        closeModal();
        txStart();
      }).on('error', function(error) {
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }).then(function(receipt) {
        updatePage()
        txDone()
        setTimeout(() => {
          txAfterDone()
        }, 2000)
      });
    } catch (error) {
      txDone();
      txAfterDone();
      Swal.fire({
        title: "Please try again",
        text: error.message,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    }
  }

  const afterOpenModal = () => {
    setAmount('');
  };

  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} onAfterOpen={afterOpenModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="PTGCSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont"><span style={{display: 'block',fontSize: '47px'}}>Unstake PTGC</span></h2>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-12 col-md-6 col-lg-5">
                  <div className="">
                  <div className="bSRIN overHide p-0">
                  <div className="bSRIN overHide mt-0 w-5100" style={{ border: '0px', borderRadius:'0px', borderBottom: '0px solid #383835' }}>
                    <div className="amountSTaking d-flex1 justify-content-between align-items-center gap-3" >
                      <div className="inputBGCOin d-flex gap-2 w-100">
                        <img className="img-fluid" src="./images/ptgccircle.svg" />
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder="0.00"
                          value={
                            amount === "" || isNaN(Number(amount.toString().replace(/,/g, "")))
                              ? ""
                              : Number(amount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setAmount("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(stakedpTGC));
                            setAmount(num.toString());
                          }}
                        />
                      </div>
                      <div className="perVal fInter d-flex align-items-center mt-3"><span className="">Available Amount : <span className="text-white">{parseFloat(stakedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PTGC</span></span></div>
                      <div className="someBtns d-flex gap-2 mt-3 modnoCOlo">
                        <button className="someSnbtn w-100" onClick={() => { setAmount((25 / 100) * stakedpTGC) }}><span>25%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((50 / 100) * stakedpTGC) }}><span>50%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((75 / 100) * stakedpTGC) }}><span>75%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((MAX_UNSTAKE_BPS / BPS_DENOMINATOR) * stakedpTGC) }}><span>MAX</span></button>
                      </div>
                    </div>
                  </div>
                  <div className="someBtns SRTOP  d-flex gap-2 mt-0 p-2">
                    {
                      amount > 0 ?
                      <>
                        <button className="someSnbtn" onClick={() => { unstake() }}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Unstake Now
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MinusCircle.svg" />
                            </div>
                          </span>
                        </button>
                      </>
                      :
                      <>
                        <button className="someSnbtn" disabled>
                          <span className="d-flex align-items-center w-100 justify-content-between">Unstake Now
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MinusCircle.svg" />
                            </div>
                          </span>
                        </button>
                      </>
                    }
                  </div>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </Modal>
    </>
  );
};

export default UnstakeModal;